/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `An error has occurred`
};

const fr_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite`
};

const de_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `Ein Fehler ist aufgetreten`
};

const es_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `Se ha producido un error`
};

const it_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `C'è stato un errore`
};

const ar_unexpected_error_message22 = /** @type {(inputs: {}) => string} */ () => {
	return `حدث خطأ.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const unexpected_error_message22 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.unexpected_error_message22(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("unexpected_error_message22", locale)
	if (locale === "en") return en_unexpected_error_message22(inputs)
	if (locale === "fr") return fr_unexpected_error_message22(inputs)
	if (locale === "de") return de_unexpected_error_message22(inputs)
	if (locale === "es") return es_unexpected_error_message22(inputs)
	if (locale === "it") return it_unexpected_error_message22(inputs)
	return ar_unexpected_error_message22(inputs)
};
export { unexpected_error_message22 as "UNEXPECTED_ERROR_MESSAGE" }